const getStatus = (label) => {
    switch (label) {
        case 'passport': return 'Паспорт';
        case 'selfie_passport': return 'Селфи с паспортом';
        case 'selfie_card': return 'Селфи с картой';
        case 'photo_window_passport': return 'Фото паспорта'
        default: return '-'
     }
}

export {
    getStatus
}